import { CellContext, ColumnDef } from '@tanstack/react-table';
import { formatDate } from '@UIComponents/utils/formatters';

import { getImpressionCell } from './cellRenderers/ImpressionCell';
import { getStationCellRenderer } from './cellRenderers/getStationCellRenderer';
import { getStationCountryRenderer } from './cellRenderers/getStationCountryRenderer';
import { getInfoCellRenderer } from './cellRenderers/getInfoCellRenderer';

import type { ExtendedViewership } from './types';

export const columnDefs = (
  onEditManualViewership: (id: string) => void,
): ColumnDef<ExtendedViewership, unknown>[] => [
  {
    id: 'viewershipType',
    header: '',
    accessorFn: (row: ExtendedViewership) => {
      if (row.isPrimaryViewership) {
        return 'Primary';
      }
      if (row.hasSecondaryLabel) {
        return 'Secondary';
      }
      if (row.isPinnedBottom) {
        return row.label ?? 'Total';
      }
      return '';
    },
  },
  {
    id: 'station.displayName',
    header: 'Station',
    accessorKey: 'station.displayName',
    cell: (params: CellContext<ExtendedViewership, unknown>) =>
      getStationCellRenderer({ data: params.row.original }),
  },
  {
    id: 'station.country',
    header: 'Country',
    accessorKey: 'station.country',
    cell: (params: CellContext<ExtendedViewership, unknown>) =>
      getStationCountryRenderer({ data: params.row.original }),
  },
  {
    id: 'premiereDate',
    header: 'Air Date',
    accessorKey: 'premiereDate',
    cell: (info: CellContext<ExtendedViewership, unknown>) =>
      formatDate(info.getValue() as string),
  },
  {
    id: 'premiereImpressions',
    header: 'Premiere',
    accessorKey: 'premiereImpressions',
    cell: getImpressionCell,
  },
  {
    id: 'past30Impressions',
    header: '30 days',
    accessorKey: 'past30Impressions',
    cell: getImpressionCell,
  },
  {
    id: 'past60Impressions',
    header: '60 days',
    accessorKey: 'past60Impressions',
    cell: getImpressionCell,
  },
  {
    id: 'past90Impressions',
    header: '90 days',
    accessorKey: 'past90Impressions',
    cell: getImpressionCell,
  },
  {
    id: 'past365Impressions',
    header: '365 days',
    accessorKey: 'past365Impressions',
    cell: getImpressionCell,
  },
  {
    id: 'info',
    header: '',
    accessorKey: 'info',
    cell: (info: CellContext<ExtendedViewership, unknown>) =>
      getInfoCellRenderer(
        { data: info.row.original },
        onEditManualViewership,
        true,
      ),
  },
];
